import { apiErrorCode } from '../../../utils/apiError';

export type RushMidErrorKey =
  | 'partyErrNotFound'
  | 'partyErrInGame'
  | 'partyErrFull'
  | 'partyErrInMatch'
  | 'maintenanceErr'
  | 'balanceErr'
  | 'multiaccErr';

/**
 * Коды отказа Rush Mid → ключ перевода. Карта своя у Rush Mid и живёт рядом с ним; текст
 * по-прежнему выбирает экран, здесь только соответствие.
 *
 * `MULTIACC_NOT_ALLOWED` намеренно ведёт на размытое «Ты не можешь присоединиться сюда»:
 * точная причина подсказала бы, как обойти защиту (#516).
 */
const ERR_KEY = new Map<string, RushMidErrorKey>([
  ['PARTY_NOT_FOUND', 'partyErrNotFound'],
  ['PARTY_IN_GAME', 'partyErrInGame'],
  ['PARTY_FULL', 'partyErrFull'],
  ['IN_ACTIVE_MATCH', 'partyErrInMatch'],
  ['MAINTENANCE', 'maintenanceErr'],
  ['INSUFFICIENT_RESOURCES', 'balanceErr'],
  ['MULTIACC_NOT_ALLOWED', 'multiaccErr'],
]);

/** Ключ перевода для отказа, либо `undefined` — что показать тогда, решает экран. */
export function rushMidErrorKey(err: unknown): RushMidErrorKey | undefined {
  const code = apiErrorCode(err);
  return code ? ERR_KEY.get(code) : undefined;
}
